class CartDrawer extends HTMLElement {
	constructor() {
		super();
	}
	
	connectedCallback() {
		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
		this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
		this.setHeaderCartIconAccessibility();
	}
	
	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		if (!cartLink) return;
		
		cartLink.setAttribute('role', 'button');
		cartLink.setAttribute('aria-haspopup', 'dialog');
		cartLink.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			this.open(cartLink);
		});
		cartLink.addEventListener('keydown', (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}
	
	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'active');
		});
		
		this.addEventListener(
		  'transitionend',
		  () => {
			  const containerToTrapFocusOn = this.classList.contains('is-empty')
				? this.querySelector('.cart-drawer__warnings')
				: document.getElementById('CartDrawer');
			  const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
			  trapFocus(containerToTrapFocusOn, focusElement);
		  },
		  {once: true}
		);
		
		theme.initComponents($(this));
		document.body.classList.add('overflow-hidden');
	}
	
	close() {
		this.classList.remove('active');
		document.body.classList.remove('overflow-hidden');
	}
	
	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');
		
		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
		}
		
		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
		});
	}
	
	renderContents(parsedState) {
		this.classList.toggle('is-empty', parsedState.quantity === 0);
		this.querySelector('.cart-drawer__items')?.classList.toggle('is-empty', parsedState.quantity === 0);
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
			  ? document.querySelector(section.selector)
			  : document.getElementById(section.id);
			
			if (!sectionElement) return;
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
		});
		
		setTimeout(() => {
			this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
			this.open();
			const scrollContainer = this.querySelector('.cart-items-wrapper');
			if (scrollContainer) {
				scrollContainer.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
		});
	}
	
	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}
	
	getSectionsToRender() {
		return [
			{
				id: 'drawer-cart-items',
				section: this.closest('.shopify-section').id.replace('shopify-section-', ''),
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: document.getElementById('cart-icon-bubble').dataset.id,
				selector: '.js-icon',
			},
			{
				id: 'drawer-cart-footer',
				section: this.closest('.shopify-section').id.replace('shopify-section-', ''),
				selector: '.js-contents-footer',
			}
		];
	}
	
	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}
	
	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'drawer-cart-items',
				section: this.closest('.shopify-section').id.replace('shopify-section-', ''),
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: document.getElementById('cart-icon-bubble').dataset.id,
				selector: '.js-icon',
			},
			{
				id: 'drawer-cart-footer',
				section: this.closest('.shopify-section').id.replace('shopify-section-', ''),
				selector: '.js-contents-footer',
			}
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
